export default __webpack_public_path__ + "51b2498d2f6a0186a6c5a5ddb54e6d21.png";